import { IIconBase } from '..'

const xRomaneioIcon = ({
  color = '#333752',
  height = 24,
  width = 25,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='vuesax/linear/x-romaneio'>
        <g id='x-romaneio'>
          <path
            id='Vector'
            d='M15.5 2V12C15.5 13.1 14.6 14 13.5 14H2.5V6C2.5 3.79 4.29 2 6.5 2H15.5Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_2'
            d='M22.5 14V17C22.5 18.66 21.16 20 19.5 20H18.5C18.5 18.9 17.6 18 16.5 18C15.4 18 14.5 18.9 14.5 20H10.5C10.5 18.9 9.6 18 8.5 18C7.4 18 6.5 18.9 6.5 20H5.5C3.84 20 2.5 18.66 2.5 17V14H13.5C14.6 14 15.5 13.1 15.5 12V5H17.34C18.06 5 18.72 5.39001 19.08 6.01001L20.79 9H19.5C18.95 9 18.5 9.45 18.5 10V13C18.5 13.55 18.95 14 19.5 14H22.5Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_3'
            d='M8.5 22C9.60457 22 10.5 21.1046 10.5 20C10.5 18.8954 9.60457 18 8.5 18C7.39543 18 6.5 18.8954 6.5 20C6.5 21.1046 7.39543 22 8.5 22Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_4'
            d='M16.5 22C17.6046 22 18.5 21.1046 18.5 20C18.5 18.8954 17.6046 18 16.5 18C15.3954 18 14.5 18.8954 14.5 20C14.5 21.1046 15.3954 22 16.5 22Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            id='Vector_5'
            d='M22.5 12V14H19.5C18.95 14 18.5 13.55 18.5 13V10C18.5 9.45 18.95 9 19.5 9H20.79L22.5 12Z'
            stroke={color}
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <g id='Group'>
            <path
              id='Vector_6'
              d='M11.4999 10.9511L6.07324 5.52441'
              stroke='#DC3545'
              strokeWidth='1.5'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector_7'
              d='M11.457 5.58936L6.03027 11.0161'
              stroke='#DC3545'
              strokeWidth='1.5'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default xRomaneioIcon
